import { useState, useEffect } from 'react';
import { legalPageAPI } from '../../services/api';
import { FileText, Edit2, Plus, Trash2, X, Save } from 'lucide-react';

export default function LegalPagesAdmin() {
    const [pages, setPages] = useState([]);
    const [editPage, setEditPage] = useState(null);
    const [form, setForm] = useState({ slug: '', title: '', content: '' });
    const [showForm, setShowForm] = useState(false);

    const loadPages = async () => {
        try {
            const res = await legalPageAPI.getAllAdmin();
            setPages(res.data);
        } catch (e) { console.error(e); }
    };

    useEffect(() => { loadPages(); }, []);

    const openEdit = (page) => {
        setEditPage(page);
        setForm({ slug: page.slug, title: page.title, content: page.content || '' });
        setShowForm(true);
    };

    const openNew = () => {
        setEditPage(null);
        setForm({ slug: '', title: '', content: '' });
        setShowForm(true);
    };

    const handleSave = async () => {
        try {
            if (editPage) {
                await legalPageAPI.update(editPage.id, form);
            } else {
                await legalPageAPI.create(form);
            }
            setShowForm(false);
            loadPages();
        } catch (e) {
            alert(e.response?.data?.error || 'Hata oluştu');
        }
    };

    const handleDelete = async (id) => {
        if (!confirm('Bu sayfayı silmek istediğinize emin misiniz?')) return;
        try {
            await legalPageAPI.delete(id);
            loadPages();
        } catch (e) { console.error(e); }
    };

    return (
        <div className="admin-section">
            <div className="admin-section-header">
                <h2><FileText size={22} /> Hukuki Sayfalar</h2>
                <button className="btn btn-primary btn-sm" onClick={openNew}><Plus size={16} /> Yeni Sayfa</button>
            </div>

            <div className="admin-table-wrap">
                <table className="admin-table">
                    <thead>
                        <tr><th>Başlık</th><th>Slug</th><th>İşlem</th></tr>
                    </thead>
                    <tbody>
                        {pages.map(page => (
                            <tr key={page.id}>
                                <td><strong>{page.title}</strong></td>
                                <td><code>/sayfa/{page.slug}</code></td>
                                <td>
                                    <button className="btn btn-sm btn-secondary" onClick={() => openEdit(page)}><Edit2 size={14} /></button>
                                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(page.id)} style={{marginLeft:'0.5rem'}}><Trash2 size={14} /></button>
                                </td>
                            </tr>
                        ))}
                        {pages.length === 0 && <tr><td colSpan={3} style={{textAlign:'center',padding:'2rem',color:'var(--text-muted)'}}>Henüz sayfa yok</td></tr>}
                    </tbody>
                </table>
            </div>

            {showForm && (
                <div className="admin-modal-overlay" onClick={() => setShowForm(false)}>
                    <div className="admin-modal admin-modal-lg" onClick={e => e.stopPropagation()}>
                        <div className="admin-modal-header">
                            <h3>{editPage ? 'Sayfayı Düzenle' : 'Yeni Sayfa'}</h3>
                            <button onClick={() => setShowForm(false)}><X size={20} /></button>
                        </div>
                        <div className="admin-modal-body">
                            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'0.75rem', marginBottom:'1rem'}}>
                                <div>
                                    <label>Başlık</label>
                                    <input className="admin-input" value={form.title} onChange={e => setForm({...form, title: e.target.value})} placeholder="Gizlilik Sözleşmesi" />
                                </div>
                                <div>
                                    <label>Slug</label>
                                    <input className="admin-input" value={form.slug} onChange={e => setForm({...form, slug: e.target.value})} placeholder="gizlilik-sozlesmesi" disabled={!!editPage} />
                                </div>
                            </div>
                            <div>
                                <label>İçerik (HTML)</label>
                                <textarea
                                    className="admin-input"
                                    value={form.content}
                                    onChange={e => setForm({...form, content: e.target.value})}
                                    rows={15}
                                    style={{fontFamily:'monospace', fontSize:'0.85rem'}}
                                    placeholder="<h2>Başlık</h2><p>İçerik...</p>"
                                />
                            </div>
                        </div>
                        <div className="admin-modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowForm(false)}>İptal</button>
                            <button className="btn btn-primary" onClick={handleSave}><Save size={16} /> Kaydet</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
